import { render, staticRenderFns } from "./barginAddAndEdit.vue?vue&type=template&id=73d2770c&scoped=true"
import script from "./barginAddAndEdit.vue?vue&type=script&lang=js"
export * from "./barginAddAndEdit.vue?vue&type=script&lang=js"
import style0 from "./barginAddAndEdit.vue?vue&type=style&index=0&id=73d2770c&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73d2770c",
  null
  
)

export default component.exports